import { useQuery } from "react-query"
import { get_listing_skills } from "../../services/jobs";


const useListingSkills = (id) => {
    return useQuery(['get_listing_skills', id], () => get_listing_skills(id))
}

export default useListingSkills;